import { types } from 'mobx-state-tree';

export const PharmacyNeighborIntermediate = types.model('PharmacyNeighborIntermediate', {
  pharmacyId: types.integer,
  neighborId: types.integer,
  distance: types.maybe(types.integer),
});
